{
  "account": {
    "tab": "Standard",
    "title": "Sign in to Mezmo",
    "subtitle": "New here? <1>Start a free trial</1>"
  },
  "enterprise": {
    "tab": "Enterprise",
    "title": "Enterprise sign in",
    "subtitle": "Sign in to your Mezmo Enterprise account."
  },
  "sso": {
    "tab": "Single Sign-On",
    "title": "Single sign-on",
    "subtitle": "Enter your work email and we'll redirect you to your identity provider."
  },
  "form": {
    "with": "{{service}}",
    "email": "Work email",
    "emailPlaceholder": "you@company.com",
    "password": "Password",
    "showPassword": "Show",
    "hidePassword": "Hide",
    "signIn": "Sign in",
    "signInSSO": "Continue with SSO",
    "continue": "Continue",
    "checkingSSO": "Checking…",
    "noSsoFound": "No single sign-on is configured for that email. Try the Standard or Enterprise tab.",
    "ssoEnterEmail": "Enter your work email first.",
    "forgotPassword": "Forgot password?",
    "signUp": "Sign Up",
    "keepSignedIn": "Keep me signed in",
    "orContinueWith": "or continue with",
    "orSignInWithEmail": "or sign in with email"
  },
  "brand": {
    "headline": "Observability that answers back.",
    "subtitle": "Ask plain-English questions across your logs, metrics, and pipelines. Find incidents, reduce noise, cut costs.",
    "stat1Value": "4.2 PB",
    "stat1Label": "Daily ingest",
    "stat2Value": "99.99%",
    "stat2Label": "Uptime SLA",
    "stat3Value": "< 200 ms",
    "stat3Label": "Query p95"
  },
  "enterprise_providers": {
    "label": "Supported providers",
    "help": "Don't know your IdP?",
    "contactAdmin": "Contact your admin",
    "setupDocs": "view setup docs"
  }
}
